<template>
  <div class="bg-white rounded-lg shadow">
    <div class="bg-white rounded-lg shadow overflow-hidden">
      <div class="divide-y divide-gray-200 lg:grid lg:grid-cols-12 lg:divide-y-0 lg:divide-x">
        <aside class="py-6 lg:col-span-3">
          <nav class="space-y-1">
            <slot name="items" />
          </nav>
        </aside>
        <section class="divide-y divide-gray-200 lg:col-span-9">
          <slot name="main" />
        </section>
      </div>
    </div>
  </div>
</template>
